import React, { useState } from 'react';
import { Transition, Checkbox, Input } from "semantic-ui-react";
import RelatorioCard from './RelatorioCard';
import api from '../../../api';
import { base64toBlob } from '../../../utils/fileSaverHelper';
import { saveAs } from 'file-saver';

const PDF = 'application/pdf';
const DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const EditarVotacaoRelatorios = ({ visible, votacao, condominio }) => {
  const [showDocumentPresenceList, setShowDocumentPresenceList] = useState(true);
  const [showVoteList, setShowVoteList] = useState(false);
  const [showDeviceInfo, setShowDeviceInfo] = useState(false);
  const [showEmail, setShowEmail] = useState(true);
  const [showVoteListForResult, setShowVoteListForResult] = useState(false);
  const [quorumMinimo, setQuorumMinimo] = useState('50');

  const gerarRelatorioPresenca = async () => {
    const response = await api.votacao.gerarRelatorioPresenca(votacao._id, condominio, showDocumentPresenceList, showDeviceInfo, showEmail);
    saveAs(await base64toBlob(response.data, PDF), 'relatorio-lista-presenca.pdf');
  };

  const gerarRelatorioResultadoVotacao = async () => {
    const response = await api.votacao.gerarRelatorioResultadoVotacao(votacao._id, condominio, showVoteListForResult);
    saveAs(await base64toBlob(response.data, PDF), 'relatorio-resultado-votacao.pdf');
  };

  const gerarRelatorioQuorum = async () => {
    const minimo = parseFloat(String(quorumMinimo).replace(',', '.'));
    const response = await api.votacao.gerarRelatorioQuorum(votacao._id, condominio, isNaN(minimo) ? 50 : minimo);
    saveAs(await base64toBlob(response.data, PDF), 'relatorio-quorum-participacao.pdf');
  };

  const gerarRelatorioChatVotacao = async () => {
    const response = await api.votacao.gerarRelatorioChatVotacao(votacao._id, condominio);
    saveAs(await base64toBlob(response.data, PDF), 'relatorio-chat-votacao.pdf');
  };

  const gerarRelatorioAtaVotacao = async () => {
    const response = await api.votacao.gerarRelatorioAtaVotacao(votacao._id, condominio, showVoteList);
    saveAs(await base64toBlob(response.data, DOCX), 'relatorio-ata-votacao.docx');
  };

  const onChangeShowDocumentPresenceList = (e, { checked }) => {
    setShowDocumentPresenceList(checked);
  };

  const onChangeShowVoteList = (e, { checked }) => {
    setShowVoteList(checked);
  };

  const onChangeShowShowDeviceInfo = (e, { checked }) => {
    setShowDeviceInfo(checked);
  };

  const onChangeShowEmail = (e, { checked }) => {
    setShowEmail(checked);
  };

  const onChangeShowVoteListForResult = (e, { checked }) => {
    setShowVoteListForResult(checked);
  };

  const opcao = (id, rotulo, checked, onChange, dica) => (
    <label className="va-rel-opcao" htmlFor={id} title={dica}>
      <Checkbox toggle id={id} checked={checked} onChange={onChange} />
      <span>{rotulo}</span>
    </label>
  );

  return (
    <Transition
      animation="fade up"
      duration={{ show: 700, hide: 0 }}
      visible={visible}
      transitionOnMount={true}
    >
      <div>
        <p className="va-rel-intro">
          Gere os documentos oficiais desta votação. Os relatórios em PDF e a ata em Word são baixados direto no seu computador.
        </p>
        <div className="va-rel-grid">
          <RelatorioCard
            icon="users"
            titulo="Lista de Presença"
            descricao="Quem participou da votação, com unidade e registro de acesso."
            formato="PDF"
            onGerar={gerarRelatorioPresenca}
          >
            {opcao('chbDoc', 'Incluir CPF/CNPJ do responsável', showDocumentPresenceList, onChangeShowDocumentPresenceList, 'Exibe o CPF/CNPJ do responsável na lista de presença.')}
            {opcao('chbEmail', 'Incluir e-mail do responsável', showEmail, onChangeShowEmail, 'Exibe o e-mail do responsável na lista de presença.')}
            {opcao('chbDevice', 'Incluir MAC Address e dispositivo', showDeviceInfo, onChangeShowShowDeviceInfo, 'Exibe o MAC Address e o dispositivo usado no voto.')}
          </RelatorioCard>

          <RelatorioCard
            icon="check square outline"
            titulo="Resultado da Votação"
            descricao="Votos e percentuais de cada pauta, com barras de distribuição."
            formato="PDF"
            onGerar={gerarRelatorioResultadoVotacao}
          >
            {!condominio.votoSecreto
              ? opcao('chbVotosResultado', 'Incluir os votos de cada participante', showVoteListForResult, onChangeShowVoteListForResult, 'Exibe quem votou em cada alternativa.')
              : <span className="va-rel-nota">Votação secreta: os votos individuais não são exibidos.</span>}
          </RelatorioCard>

          <RelatorioCard
            icon="chart pie"
            titulo="Quórum e Participação"
            descricao="Participação por bloco, ausentes e impedidos. Confirma se o quórum foi atingido."
            formato="PDF"
            onGerar={gerarRelatorioQuorum}
          >
            <label className="va-rel-opcao" htmlFor="quorumMinimo">
              <span>Quórum mínimo exigido</span>
              <Input
                id="quorumMinimo"
                size="mini"
                type="number"
                min="0"
                max="100"
                label={{ basic: true, content: '%' }}
                labelPosition="right"
                value={quorumMinimo}
                onChange={e => setQuorumMinimo(e.target.value)}
                style={{ width: 110 }}
              />
            </label>
          </RelatorioCard>

          <RelatorioCard
            icon="comments outline"
            titulo="Chat da Votação"
            descricao="Todas as mensagens trocadas em cada pauta, em ordem cronológica."
            formato="PDF"
            onGerar={gerarRelatorioChatVotacao}
          />

          <RelatorioCard
            icon="file word"
            titulo="Ata da Assembleia"
            descricao="Documento editável com pauta e resultados, pronto para revisão e assinatura."
            formato="Word"
            onGerar={gerarRelatorioAtaVotacao}
          >
            {!condominio.votoSecreto
              ? opcao('chbVotosAta', 'Incluir os votos de cada participante', showVoteList, onChangeShowVoteList, 'Exibe quem votou em cada alternativa.')
              : <span className="va-rel-nota">Votação secreta: os votos individuais não são exibidos.</span>}
          </RelatorioCard>
        </div>
      </div>
    </Transition>
  );
};

export default EditarVotacaoRelatorios;
